import {requirePermission} from '@/modules/auth/permissions'
import {DrugTypeToIconMap} from '@/modules/drug-catalog/constants'
import {useGetTradeName} from '@/modules/products/trade-names/api/use-get-trade-name'
import {TradeNameForm} from '@/modules/products/trade-names/components/trade-name-form/trade-name-form'
import {EditResourceTitle} from '@/shared/components/ui/edit-resource-title'
import {NewTradeNamePageSearchSchema} from '@/modules/products/trade-names/schemas'
import {Badge, HStack} from '@chakra-ui/react'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/configuration/products/trade-names/new')({
  beforeLoad: requirePermission('catalogue.manage'),
  component: NewTradeNamePage,
  validateSearch: NewTradeNamePageSearchSchema,
})

function NewTradeNamePage() {
  const {t: tCommon} = useTranslate('common')
  const {t} = useTranslate('trade-names')
  const {tradeNameId, type} = Route.useSearch()
  const [tradeName] = useGetTradeName(tradeNameId)

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={
          <HStack width="100%" justifyContent="space-between">
            {tradeNameId ? (
              <EditResourceTitle label={t('edit_trade_name_title')} name={tradeName?.name} />
            ) : (
              t('new_trade_name_title')
            )}{' '}
            {type && (
              <Badge size="md" colorPalette="cyan" variant="subtle" flexShrink="0">
                {tCommon(type)}
                {DrugTypeToIconMap[type]?.({})}
              </Badge>
            )}
          </HStack>
        }
        description={t('new_trade_name_description')}
      />

      <TradeNameForm tradeNameId={tradeNameId} type={type} />
    </NewResourceFormContainer>
  )
}
